(() => {
  if (window.__clarusPurchasePanelBooted) return;
  window.__clarusPurchasePanelBooted = true;

  function moneyFromCents(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(
        cents,
        moneyFormat || window.theme?.moneyFormat || window.Shopify.money_format
      );
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function getAdjustment(plan, baseCents) {
    const adj = plan?.price_adjustments?.[0];
    if (!adj) {
      return {
        subCents: baseCents,
        savingsCents: 0,
        savingsPct: 0
      };
    }

    const type = adj.value_type;
    const val = Number(adj.value || 0);

    let subCents = baseCents;

    if (type === 'percentage') {
      subCents = Math.round(baseCents * (1 - val / 100));
    } else if (type === 'fixed_amount') {
      subCents = Math.max(0, baseCents - Math.round(val));
    } else if (type === 'price') {
      subCents = Math.max(0, Math.round(val));
    }

    const savingsCents = Math.max(0, baseCents - subCents);
    const savingsPct = baseCents > 0 ? Math.round((savingsCents * 100) / baseCents) : 0;

    return { subCents, savingsCents, savingsPct };
  }

  function getVariantIdFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const id = Number(params.get('variant'));
      return id || null;
    } catch (e) {
      return null;
    }
  }

  function init(panel) {
    if (panel.dataset.pdpPurchaseReady === 'true') return;
    panel.dataset.pdpPurchaseReady = 'true';

    const form = panel.querySelector('form.clarus-purchase-form');
    if (!form) return;

    const sectionRoot =
      panel.closest('.shopify-section') ||
      panel.closest('[data-product-section]') ||
      document;

    const moneyFormat = panel.dataset.moneyFormat || window.Shopify?.money_format;

    const oneCard = panel.querySelector('[data-purchase-card="onetime"]');
    const subCard = panel.querySelector('[data-purchase-card="sub"]');
    const cards = panel.querySelectorAll('[data-purchase-card]');

    const qtyOnetime = panel.querySelector('[data-qty="onetime"]');
    const qtySub = panel.querySelector('[data-qty="sub"]');

    const sellingPlanInput = panel.querySelector('[data-selling-plan-input]');
    const sellingPlanSelect = panel.querySelector('[data-selling-plan-select]');

    const btnOnetimeAdd = oneCard?.querySelector('button[type="submit"][name="add"]');
    const buyNowWrap = oneCard?.querySelector('.purchase-card__buy-now');
    const btnSubAdd = subCard?.querySelector('button[type="submit"][name="add"]');

    const priceOne = panel.querySelector('[data-price-onetime]');
    const eachOne = panel.querySelector('[data-each-onetime]');

    const priceSub = panel.querySelector('[data-price-sub]');
    const eachSub = panel.querySelector('[data-each-sub]');
    const savingsSub = panel.querySelector('[data-savings-sub]');
    const onetimeSub = panel.querySelector('[data-onetime-sub]');

    const variantsScript = panel.querySelector('[data-pdp-variants]');
    const plansScript = panel.querySelector('[data-pdp-selling-plans]');

    let variants = [];
    let plansData = null;
    let plans = [];

    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
    } catch (e) {
      variants = [];
    }

    try {
      plansData = plansScript ? JSON.parse(plansScript.textContent || '{}') : null;
      plans = plansData?.plans || [];
    } catch (e) {
      plansData = null;
      plans = [];
    }

    const initialVariantId = Number(panel.dataset.currentVariantId || 0);

    const state = {
      currentVariantId: initialVariantId,
      activeType: oneCard?.classList.contains('is-active') ? 'onetime' : 'sub',
      pdpObserverAttached: false,
      isApplyingPdpOverride: false,
      subPriceObserverAttached: false,
      isApplyingSubCardOverride: false
    };

    function setDisabled(el, disabled) {
      if (!el) return;
      el.disabled = !!disabled;
      el.toggleAttribute('disabled', !!disabled);
      el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function setWrapDisabled(wrap, disabled) {
      if (!wrap) return;
      wrap.classList.toggle('is-disabled', !!disabled);
      wrap.style.pointerEvents = disabled ? 'none' : '';
      wrap.style.opacity = disabled ? '0.55' : '';
    }

    function getDefaultPlan() {
      if (!plans.length) return null;
      return (
        plans.find(p => Number(p.id) === Number(plansData?.default_plan_id)) ||
        plans[0] ||
        null
      );
    }

    function getCurrentPlan() {
      if (!sellingPlanSelect || !plans.length) return getDefaultPlan();
      const id = Number(sellingPlanSelect.value);
      return plans.find(p => Number(p.id) === id) || getDefaultPlan();
    }

    function getPanelVariantInput() {
      return form.querySelector('input[name="id"]');
    }

    function getVariantById(id) {
      return variants.find(v => Number(v.id) === Number(id)) || null;
    }

    function getMasterVariantInputs() {
      const all = Array.from(sectionRoot.querySelectorAll('input[name="id"]'));

      return all.filter((input) => {
        if (panel.contains(input)) return false;
        const val = Number(input.value);
        return !!getVariantById(val);
      });
    }

    function syncPanelVariantInput(id) {
      const panelInput = getPanelVariantInput();
      if (panelInput && Number(panelInput.value) !== Number(id)) {
        panelInput.value = String(id);
        panelInput.setAttribute('value', String(id));
      }
    }

    function syncCurrentVariantId(id) {
      const numericId = Number(id);
      if (!numericId || !getVariantById(numericId)) return;

      state.currentVariantId = numericId;
      panel.dataset.currentVariantId = String(numericId);
      syncPanelVariantInput(numericId);

      const rerender = () => {
        renderPrices();
        stabilizeSubCardPrice();
        updatePdpPriceDisplay();
      };

      requestAnimationFrame(rerender);
      setTimeout(rerender, 80);
      setTimeout(rerender, 180);
      setTimeout(rerender, 320);
    }

    function getCurrentVariant() {
      if (state.currentVariantId) {
        const byState = getVariantById(state.currentVariantId);
        if (byState) return byState;
      }

      const urlId = getVariantIdFromUrl();
      if (urlId) {
        const byUrl = getVariantById(urlId);
        if (byUrl) {
          state.currentVariantId = urlId;
          panel.dataset.currentVariantId = String(urlId);
          syncPanelVariantInput(urlId);
          return byUrl;
        }
      }

      const masterInputs = getMasterVariantInputs();
      for (const input of masterInputs) {
        const id = Number(input.value);
        const match = getVariantById(id);
        if (match) {
          state.currentVariantId = id;
          panel.dataset.currentVariantId = String(id);
          syncPanelVariantInput(id);
          return match;
        }
      }

      const panelInput = getPanelVariantInput();
      if (panelInput?.value) {
        const byPanelInput = getVariantById(Number(panelInput.value));
        if (byPanelInput) return byPanelInput;
      }

      return getVariantById(Number(panel.dataset.currentVariantId)) || variants[0] || null;
    }

    function getAllocationPrice(allocation) {
      const possiblePrices = [
        allocation?.price,
        allocation?.per_delivery_price,
        allocation?.checkout_charge_amount,
        allocation?.remaining_balance_charge_amount
      ];

      for (const val of possiblePrices) {
        if (val !== null && val !== undefined && val !== '') {
          return Number(val);
        }
      }

      return null;
    }

    function getSubscriptionPriceFromAllocations(variant, plan) {
      if (!variant || !plan || !Array.isArray(variant.selling_plan_allocations)) return null;

      let matched =
        variant.selling_plan_allocations.find(
          (allocation) => Number(allocation.selling_plan_id) === Number(plan.id)
        ) || null;

      if (!matched && variant.selling_plan_allocations.length === 1) {
        matched = variant.selling_plan_allocations[0];
      }

      if (!matched) return null;

      const allocationPrice = getAllocationPrice(matched);
      if (allocationPrice == null || Number.isNaN(allocationPrice)) return null;

      return allocationPrice;
    }

    function getSubscriptionPricing(variant, plan) {
      const baseCents = Number(variant?.price || 0);

      const allocationPrice = getSubscriptionPriceFromAllocations(variant, plan);
      if (allocationPrice != null) {
        const savingsCents = Math.max(0, baseCents - allocationPrice);
        const savingsPct = baseCents > 0 ? Math.round((savingsCents * 100) / baseCents) : 0;

        return {
          subCents: allocationPrice,
          savingsCents,
          savingsPct
        };
      }

      return getAdjustment(plan, baseCents);
    }

    

    function lockEachPrices() {
      const variant = getCurrentVariant();
      if (!variant) return;

      const rawCostPerItem = Number(variant.cost_per_item);

      if (eachOne && !isNaN(rawCostPerItem) && rawCostPerItem > 0) {
        eachOne.textContent =
          `(${moneyFromCents(rawCostPerItem, moneyFormat)} / count)`;
      }
    }

    function applySubPriceDisplay(
      subCents,
      baseCents,
      savingsCents,
      savingsPct
    ) {
      const subMoney = moneyFromCents(subCents, moneyFormat);
      const baseMoney = moneyFromCents(baseCents, moneyFormat);

      state.isApplyingSubCardOverride = true;

      if (priceSub) {
        priceSub.textContent = subMoney;
        priceSub.setAttribute(
          'data-sub-price-cents',
          String(subCents)
        );
        priceSub.setAttribute(
          'data-sub-price-money',
          subMoney
        );
      }

      /*
      * SUBSCRIBE & SAVE COST PER ITEM
      *
      * Take the regular cost_per_item and apply
      * the exact Bold subscription discount ratio.
      */
      const variant = getCurrentVariant();
      const rawCostPerItem = Number(variant?.cost_per_item || 0);

      if (eachSub) {
        if (rawCostPerItem > 0 && baseCents > 0) {

          // Example:
          // Bold price = $95
          // Regular price = $100
          // ratio = .95
          const subscriptionRatio = subCents / baseCents;

          // $25.99 × .95 = $24.6905
          const discountedCostPerItem = Math.round(
            rawCostPerItem * subscriptionRatio
          );

          eachSub.textContent =
            `(${moneyFromCents(
              discountedCostPerItem,
              moneyFormat
            )} / count)`;

        } else {
          eachSub.textContent = '';
        }
      }

      if (savingsSub) {
        savingsSub.textContent =
          savingsCents > 0
            ? `You Save ${moneyFromCents(
                savingsCents,
                moneyFormat
              )} (-${savingsPct}%)`
            : '';
      }

      if (onetimeSub) {
        onetimeSub.textContent =
          savingsCents > 0
            ? `One-Time Price: ${baseMoney}`
            : '';
      }

      requestAnimationFrame(() => {
        state.isApplyingSubCardOverride = false;
      });
    }

    function stabilizeSubCardPrice() {
      const variant = getCurrentVariant();
      if (!variant || !subCard || !plans.length) return;

      const apply = () => {
        const freshVariant = getCurrentVariant();
        if (!freshVariant) return;

        const baseCents = Number(freshVariant.price || 0);
        const plan = getCurrentPlan();

        const {
          subCents,
          savingsCents,
          savingsPct
        } = getSubscriptionPricing(
          freshVariant,
          plan
        );

        applySubPriceDisplay(
          subCents,
          baseCents,
          savingsCents,
          savingsPct
        );
      };

      apply();
      requestAnimationFrame(apply);
      setTimeout(apply, 60);
      setTimeout(apply, 140);
      setTimeout(apply, 260);
    }

    function attachSubCardPriceObserver() {
      if (state.subPriceObserverAttached || !priceSub) return;
      state.subPriceObserverAttached = true;

      const observer = new MutationObserver(() => {
        if (state.isApplyingSubCardOverride) return;
        stabilizeSubCardPrice();
      });

      observer.observe(priceSub, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    function getPdpPriceElements() {
      const root = sectionRoot.querySelector('.price.price--pdp');
      if (!root) return null;

      let savingsRow = root.querySelector('.pdp-savings-row');

      if (!savingsRow) {
        savingsRow = document.createElement('div');
        savingsRow.className = 'pdp-savings-row';
        savingsRow.style.display = 'none';

        const youSave = document.createElement('span');
        youSave.className = 'you-save';
        savingsRow.appendChild(youSave);

        root.appendChild(savingsRow);
      }

      let savingsText = savingsRow.querySelector('.you-save');
      if (!savingsText) {
        savingsText = document.createElement('span');
        savingsText.className = 'you-save';
        savingsRow.appendChild(savingsText);
      }

      return {
        root,
        currentAmount: root.querySelector('.top-prices ins .amount'),
        compareWrap: root.querySelector('.top-prices del'),
        compareAmount: root.querySelector('.top-prices del .amount'),
        savingsRow,
        savingsText
      };
    }

    function attachPdpObserver() {
      if (state.pdpObserverAttached) return;

      const pdp = getPdpPriceElements();
      const watchRoot = pdp?.root?.parentNode;
      if (!watchRoot) return;

      state.pdpObserverAttached = true;

      const schedule = () => {
        if (state.isApplyingPdpOverride) return;

        requestAnimationFrame(() => {
          updatePdpPriceDisplay();
        });
      };

      const observer = new MutationObserver(schedule);

      observer.observe(watchRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    function updatePdpPriceDisplay() {
      const variant = getCurrentVariant();
      const pdp = getPdpPriceElements();

      if (!variant || !pdp || !pdp.currentAmount) return;

      const baseCents = Number(variant.price || 0);

      const pdpEach = document.querySelector(
        '[data-pdp-cost-per-item]'
      );

      const regularCostPerItem =
        Number(variant.cost_per_item || 0);

      const baseMoney = moneyFromCents(
        baseCents,
        moneyFormat
      );

      const compareAtCents =
        Number(variant.compare_at_price || 0);

      state.isApplyingPdpOverride = true;


      /*
      * ONE-TIME PURCHASE
      */
      if (state.activeType !== 'sub') {
        pdp.currentAmount.textContent = baseMoney;

        pdp.currentAmount.classList.toggle(
          'discounted',
          compareAtCents > baseCents
        );

        // Regular cost per item
        if (
          pdpEach &&
          regularCostPerItem > 0
        ) {
          pdpEach.textContent =
            `(${moneyFromCents(
              regularCostPerItem,
              moneyFormat
            )} / count)`;
        }


        if (
          pdp.compareWrap &&
          pdp.compareAmount
        ) {
          if (compareAtCents > baseCents) {
            pdp.compareAmount.textContent =
              moneyFromCents(
                compareAtCents,
                moneyFormat
              );

            pdp.compareWrap.style.display = '';
          } else {
            pdp.compareAmount.textContent = '';
            pdp.compareWrap.style.display = 'none';
          }
        }


        if (
          pdp.savingsRow &&
          pdp.savingsText
        ) {
          let rightPrice =
            pdp.savingsRow.querySelector(
              '.pdp-onetime-right'
            );

          if (rightPrice) {
            rightPrice.remove();
          }

          if (compareAtCents > baseCents) {
            const saveAmount =
              compareAtCents - baseCents;

            const savePct = Math.round(
              (saveAmount * 100) /
              compareAtCents
            );

            pdp.savingsText.textContent =
              `You Save ${moneyFromCents(
                saveAmount,
                moneyFormat
              )} (-${savePct}%)`;

            pdp.savingsRow.style.display =
              'flex';
          } else {
            pdp.savingsText.textContent = '';
            pdp.savingsRow.style.display =
              'none';
          }
        }


        requestAnimationFrame(() => {
          state.isApplyingPdpOverride = false;
        });

        return;
      }


      /*
      * SUBSCRIBE & SAVE
      */
      const plan = getCurrentPlan();

      const {
        subCents,
        savingsCents,
        savingsPct
      } = getSubscriptionPricing(
        variant,
        plan
      );


      /*
      * Apply the exact Bold subscription
      * discount ratio to cost_per_item.
      */
      if (
        pdpEach &&
        regularCostPerItem > 0 &&
        baseCents > 0
      ) {
        const subscriptionRatio =
          subCents / baseCents;

        const discountedCostPerItem =
          Math.round(
            regularCostPerItem *
            subscriptionRatio
          );

        pdpEach.textContent =
          `(${moneyFromCents(
            discountedCostPerItem,
            moneyFormat
          )} / count)`;
      }


      const subMoney =
        moneyFromCents(
          subCents,
          moneyFormat
        );

      const showSubSavings =
        subCents < baseCents;


      pdp.currentAmount.textContent =
        subMoney;

      pdp.currentAmount.classList.toggle(
        'discounted',
        showSubSavings
      );


      if (
        pdp.compareWrap &&
        pdp.compareAmount
      ) {
        pdp.compareWrap.style.display =
          'none';
      }


      if (
        pdp.savingsRow &&
        pdp.savingsText
      ) {
        let rightPrice =
          pdp.savingsRow.querySelector(
            '.pdp-onetime-right'
          );

        if (!rightPrice) {
          rightPrice =
            document.createElement('span');

          rightPrice.className =
            'pdp-onetime-right';

          pdp.savingsRow.appendChild(
            rightPrice
          );
        }


        if (showSubSavings) {
          pdp.savingsText.textContent =
            `You Save ${moneyFromCents(
              savingsCents,
              moneyFormat
            )} (-${savingsPct}%)`;

          rightPrice.innerHTML =
            `One-Time Price: <s>${baseMoney}</s>`;

          pdp.savingsRow.style.display =
            'flex';
        } else {
          pdp.savingsText.textContent = '';
          rightPrice.innerHTML = '';
          pdp.savingsRow.style.display =
            'none';
        }
      }


      requestAnimationFrame(() => {
        state.isApplyingPdpOverride = false;
      });
    }


    function renderPrices() {
      const variant = getCurrentVariant();
      if (!variant) return;

      const baseCents = Number(variant.price || 0);
      const baseMoney = moneyFromCents(
        baseCents,
        moneyFormat
      );

      if (priceOne) {
        priceOne.textContent = baseMoney;
      }

      lockEachPrices();

      if (subCard && plans.length) {
        const plan = getCurrentPlan();

        const {
          subCents,
          savingsCents,
          savingsPct
        } = getSubscriptionPricing(
          variant,
          plan
        );

        applySubPriceDisplay(
          subCents,
          baseCents,
          savingsCents,
          savingsPct
        );
      }

      updatePdpPriceDisplay();
    }

    

    function setActive(type) {
      const isOne = type === 'onetime';
      state.activeType = type;

      oneCard?.classList.toggle('is-active', isOne);
      subCard?.classList.toggle('is-active', !isOne);

      if (qtyOnetime && qtySub) {
        setDisabled(qtyOnetime, !isOne);
        qtyOnetime.name = isOne ? 'quantity' : 'quantity_disabled';

        setDisabled(qtySub, isOne);
        qtySub.name = isOne ? 'quantity_disabled' : 'quantity';

        if (isOne) qtySub.value = qtyOnetime.value;
        else qtyOnetime.value = qtySub.value;
      }

      if (window.refreshClarusCustomQty) {
        window.refreshClarusCustomQty(panel);
      }

      setDisabled(btnOnetimeAdd, !isOne);
      setWrapDisabled(buyNowWrap, !isOne);

      setDisabled(sellingPlanSelect, isOne);
      setDisabled(btnSubAdd, isOne);

      if (sellingPlanInput) {
        if (isOne) {
          sellingPlanInput.value = '';
        } else {
          const selectedPlan = sellingPlanSelect?.value || getDefaultPlan()?.id || '';
          sellingPlanInput.value = selectedPlan;
        }
      }

      renderPrices();
      stabilizeSubCardPrice();

      requestAnimationFrame(() => {
        updatePdpPriceDisplay();
      });
    }

    cards.forEach(card => {
      card.addEventListener('click', (e) => {
        const isInteractive = e.target.closest('select, option, button, a, input, label');
        if (isInteractive) return;
        setActive(card.dataset.purchaseCard);
      });

      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setActive(card.dataset.purchaseCard);
        }
      });
    });

    qtyOnetime?.addEventListener('change', () => {
      if (state.activeType === 'onetime' && qtySub) {
        qtySub.value = qtyOnetime.value;
      }

      if (window.refreshClarusCustomQty) {
        window.refreshClarusCustomQty(panel);
      }
    });

    qtySub?.addEventListener('change', () => {
      if (state.activeType === 'sub' && qtyOnetime) {
        qtyOnetime.value = qtySub.value;
      }

      if (window.refreshClarusCustomQty) {
        window.refreshClarusCustomQty(panel);
      }
    });

    sellingPlanSelect?.addEventListener('change', () => {
      if (state.activeType === 'sub' && sellingPlanInput) {
        sellingPlanInput.value = sellingPlanSelect.value;
      }

      renderPrices();
      stabilizeSubCardPrice();

      requestAnimationFrame(() => {
        updatePdpPriceDisplay();
      });
    });

    const panelInput = getPanelVariantInput();
    if (panelInput) {
      panelInput.addEventListener('change', () => {
        const id = Number(panelInput.value);
        if (id && getVariantById(id)) {
          state.currentVariantId = id;
          panel.dataset.currentVariantId = String(id);
          renderPrices();
          stabilizeSubCardPrice();
        }
      });
    }

    const masterInputs = getMasterVariantInputs();
    masterInputs.forEach((input) => {
      const updateFromMaster = () => {
        const id = Number(input.value);
        if (id && getVariantById(id)) {
          syncCurrentVariantId(id);
        }
      };

      input.addEventListener('change', updateFromMaster);

      const mo = new MutationObserver(updateFromMaster);
      mo.observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    });

    document.addEventListener('variant:change', (event) => {
      const detailVariant = event?.detail?.variant;
      if (detailVariant?.id && getVariantById(detailVariant.id)) {
        syncCurrentVariantId(Number(detailVariant.id));
      }
    });

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    if (!window.__clarusPurchaseHistoryPatched) {
      window.__clarusPurchaseHistoryPatched = true;

      history.pushState = function () {
        const result = originalPushState.apply(this, arguments);
        window.dispatchEvent(new Event('clarus:historychange'));
        return result;
      };

      history.replaceState = function () {
        const result = originalReplaceState.apply(this, arguments);
        window.dispatchEvent(new Event('clarus:historychange'));
        return result;
      };
    }

    window.addEventListener('popstate', () => {
      const urlId = getVariantIdFromUrl();
      if (urlId) syncCurrentVariantId(urlId);
    });

    window.addEventListener('clarus:historychange', () => {
      const urlId = getVariantIdFromUrl();
      if (urlId) syncCurrentVariantId(urlId);
    });

    const initialUrlId = getVariantIdFromUrl();
    if (initialUrlId) {
      state.currentVariantId = Number(initialUrlId);
      panel.dataset.currentVariantId = String(initialUrlId);
      syncPanelVariantInput(initialUrlId);
    }

    attachPdpObserver();
    attachSubCardPriceObserver();

    setActive(state.activeType || 'onetime');

    renderPrices();
    lockEachPrices();
    stabilizeSubCardPrice();

    requestAnimationFrame(() => {
      renderPrices();
      stabilizeSubCardPrice();
      updatePdpPriceDisplay();
    });

    setTimeout(() => {
      renderPrices();
      stabilizeSubCardPrice();
      updatePdpPriceDisplay();
    }, 120);

    setTimeout(() => {
      stabilizeSubCardPrice();
      updatePdpPriceDisplay();
    }, 260);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-purchase-panel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

// popup info

(() => {
  function initPurchasePopup(panel) {
    if (!panel || panel.dataset.purchasePopupReady === 'true') return;
    panel.dataset.purchasePopupReady = 'true';

    const popup = panel.querySelector('.purchase-info-popup');
    if (!popup) return;

    const triggers = panel.querySelectorAll('.js-popup-trigger');
    const closeButtons = popup.querySelectorAll('[data-popup-close]');
    const dialog = popup.querySelector('.purchase-info-popup__dialog');

    if (!triggers.length || !dialog) return;

    const openPopup = (e) => {
      e.preventDefault();
      popup.hidden = false;
      document.documentElement.classList.add('purchase-info-popup-open');
      document.body.classList.add('purchase-info-popup-open');
    };

    const closePopup = () => {
      popup.hidden = true;
      document.documentElement.classList.remove('purchase-info-popup-open');
      document.body.classList.remove('purchase-info-popup-open');
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', openPopup);
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) {
        closePopup();
      }
    });

    popup.addEventListener('click', (e) => {
      if (!dialog.contains(e.target)) {
        closePopup();
      }
    });
  }

  function bootPurchasePopups() {
    document.querySelectorAll('[data-pdp-purchase-panel]').forEach(initPurchasePopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPurchasePopups);
  } else {
    bootPurchasePopups();
  }

  document.addEventListener('shopify:section:load', bootPurchasePopups);
})();

// custom qty select

(() => {
  if (window.__clarusCustomQtyInit) return;
  window.__clarusCustomQtyInit = true;

  function closeAllCustomQty(except) {
    document.querySelectorAll('.custom-qty.is-open').forEach((wrap) => {
      if (wrap !== except) {
        wrap.classList.remove('is-open');

        const trigger = wrap.querySelector('.custom-qty__trigger');
        const menu = wrap.querySelector('.custom-qty__menu');

        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      }
    });
  }

  function syncCustomQty(wrap) {
    if (!wrap) return;

    const select = wrap.querySelector('select');
    const value = wrap.querySelector('.custom-qty__value');
    const trigger = wrap.querySelector('.custom-qty__trigger');
    const options = wrap.querySelectorAll('.custom-qty__option');

    if (!select) return;

    const selected = select.options[select.selectedIndex];
    if (value && selected) value.textContent = selected.textContent;

    wrap.classList.toggle('is-disabled', !!select.disabled);

    if (trigger) {
      trigger.disabled = !!select.disabled;
      trigger.setAttribute('aria-expanded', wrap.classList.contains('is-open') ? 'true' : 'false');
    }

    options.forEach((optionEl) => {
      const isSelected = optionEl.dataset.value === select.value;
      optionEl.classList.toggle('is-selected', isSelected);
      optionEl.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  function buildCustomQty(wrap) {
    if (!wrap || wrap.dataset.customQtyBuilt === 'true') return;

    const select = wrap.querySelector('select');
    const trigger = wrap.querySelector('.custom-qty__trigger');
    const menu = wrap.querySelector('.custom-qty__menu');
    const list = wrap.querySelector('.custom-qty__list');

    if (!select || !trigger || !menu || !list) return;

    wrap.dataset.customQtyBuilt = 'true';
    list.innerHTML = '';

    Array.from(select.options).forEach((option) => {
      const item = document.createElement('li');
      item.className = 'custom-qty__option';
      item.textContent = option.textContent;
      item.dataset.value = option.value;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', option.selected ? 'true' : 'false');

      if (option.selected) item.classList.add('is-selected');

      item.addEventListener('click', () => {
        if (select.disabled) return;

        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        wrap.classList.remove('is-open');
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');

        syncCustomQty(wrap);
      });

      list.appendChild(item);
    });

    trigger.addEventListener('click', () => {
      if (select.disabled) return;

      const isOpen = wrap.classList.contains('is-open');

      closeAllCustomQty(wrap);

      wrap.classList.toggle('is-open', !isOpen);
      menu.hidden = isOpen;
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    select.addEventListener('change', () => {
      syncCustomQty(wrap);
    });

    syncCustomQty(wrap);
  }

  function initCustomQty(scope = document) {
    const wraps = scope.querySelectorAll('[data-custom-qty]');
    wraps.forEach(buildCustomQty);
    wraps.forEach(syncCustomQty);
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.custom-qty')) {
      closeAllCustomQty();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllCustomQty();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomQty(), { once: true });
  } else {
    initCustomQty();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCustomQty(event.target || document);
  });

  window.refreshClarusCustomQty = function(scope = document) {
    initCustomQty(scope);
  };
})();